module.exports = __webpack_public_path__ + "img/b9193c2.jpg";